import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import ListSubheader from "@mui/material/ListSubheader";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Packshot from "./Packshot";
import { makeStyles } from "@mui/styles";
import { CustomToolTip } from "./components/CustomToolTip";
import "../annotator.css";
import { Paper, Typography } from "@mui/material";

export default function SimilarSkusList({ similarSkusDetails }) {
  // console.log(similarSkusDetails)
  const useStyles = makeStyles((theme) => ({
    customWidth: {
      maxWidth: "13vw",
    },
  }));

  const classes = useStyles();

  const copyText = (name) => {
    navigator.clipboard.writeText(name);
  };
  const baseStylesSpan = {
    fontSize: "12px",
    color: "rgba(73 , 148, 236, 0.875)",
    backgroundColor: "#d7f3ff",
    fontFamily: "ChalkboardSE-Regular",
  };

  const maxWidth600Span = {
    fontSize: "10px",
  };

  const maxHeight700Span = {
    fontSize: "11px",
  };

  // Determine which styles to apply based on conditions
  const stylesToApplySpan = Object.assign(
    {},
    baseStylesSpan,
    window.innerHeight <= 700 && maxHeight700Span,
    window.innerHeight <= 600 && maxWidth600Span
  );

  return (
    // <Paper sx={{ padding: '0.5rem', margin: '1rem',width:"90%" }}>
    <>
      <Typography
        sx={{
          marginTop: "1rem",
          textAlign: "center",
          width: "50%",
          paddingBottom: "0.2rem",
          fontSize: "0.7rem",
          position: "relative",
          color: "rgba(73 , 148, 236, 0.875)",
          "&::before, &::after": {
            content: '""',
            position: "absolute",
            width: "40%",
            borderBottom: "2px solid rgba(73 , 148, 236, 0.875)",
            bottom: 0,
          },
          "&::before": { left: 0 },
          "&::after": { right: 0 },
          "@media screen and (max-height: 700px)": {
            width: "60%",
          },
          "@media screen and (max-height: 600px)": {
            fontSize: "0.6rem",
            width: "70%",
          },
          "&::before, &::after": {
            content: '""',
            position: "absolute",
            width: "40%",
            borderBottom: "1.5px solid rgba(73 , 148, 236, 0.875)",
            bottom: 0,
          },
        }}
      >
        Similar Skus Details
      </Typography>
      <ImageList
        className="annotator-sidebar"
        sx={{
          width: "100%",
          height: "fit-content",
          display: "flex",
          gap: "1rem",
          flexDirection: "column",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        {similarSkusDetails.map((data, index) => (
          <ImageListItem
            key={index}
            style={{
              marginBottom: "0.2rem",
              width: "100%",
              display: "flex",
              alignItems: "center",
              boxShadow: "rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px",
            }}
          >
            <Packshot image={data.packshot} />
            <CustomToolTip
              title={data.skuName}
              placement="top"
              classes={{ tooltip: classes.customWidth }}
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    width: "14vw",
                  },
                },
              }}
            >
              <ImageListItemBar
                title={<span style={stylesToApplySpan}>{data.skuName}</span>}
                sx={{
                  "& .MuiImageListItemBar-title": {
                    color: "rgba(73 , 148, 236, 0.875)",

                    "@media screen and (max-height: 700px)": {
                      fontSize: "10px",
                    },
                    "@media screen and (max-height: 600px)": {
                      fontSize: "10px",
                    },
                  },
                }}
                style={{
                  fontSize: "12px",
                  height: "1.5rem",
                  margin: "auto",
                  width: "100%",
                  backgroundColor: "#d7f3ff",
                  color: `rgba(73 , 148, 236, 0.875)`,
                }}
                actionIcon={
                  <IconButton
                    sx={{
                      backgroundColor: "#d7f3ff",
                      color: "74adf0",
                      height: "0.8rem",
                    }}
                    aria-label={`info about ${data.packshot}`}
                    onClick={() => copyText(data.skuName)}
                  >
                    <ContentCopyIcon
                      style={{ fontSize: "15px", color: "74adf0" }}
                    />
                  </IconButton>
                }
              />
            </CustomToolTip>
          </ImageListItem>
        ))}
      </ImageList>
    </>
    // </Paper>
  );
}
